import { render, staticRenderFns } from "./CompleteProfileBanner.vue?vue&type=template&id=1b1160fe"
import script from "./CompleteProfileBanner.vue?vue&type=script&lang=ts"
export * from "./CompleteProfileBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports